import { useState } from "react";
import { ExternalLink, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { money } from "@/lib/format";

const eur = (v) => money(v, "EUR", "fr-FR", { maximumFractionDigits: 2 });
export const itemsTotal = (items) => items.reduce((s, i) => s + (Number(i.price) || 0) * (Number(i.qty) || 1), 0);

export const ItemsList = ({ items, onRemove }) => (
  <ul className="space-y-1.5" data-testid="pot-items">
    {items.map((i, j) => (
      <li key={`${i.title}-${j}`} className="flex items-center gap-2 rounded-lg bg-muted/50 px-3 py-2 text-sm" data-testid={`pot-item-${j}`}>
        <span className="min-w-0 flex-1 truncate">{i.qty > 1 && <b>{i.qty} × </b>}{i.title}</span>
        {i.link && <a href={i.link} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-xs font-semibold text-primary hover:underline" data-testid={`pot-item-link-${j}`}><ExternalLink className="h-3.5 w-3.5" />Acheter</a>}
        <span className="num font-semibold">{eur(i.price * i.qty)}</span>
        {onRemove && <button type="button" onClick={() => onRemove(j)} aria-label="Retirer" data-testid={`pot-item-remove-${j}`}><Trash2 className="h-3.5 w-3.5 text-muted-foreground" /></button>}
      </li>
    ))}
  </ul>
);

export const ItemsEditor = ({ items, onChange }) => {
  const [v, setV] = useState({ title: "", link: "", price: "", qty: 1 });
  const add = () => {
    if (v.title.trim().length < 2) return;
    const link = v.link.trim() ? (/^https?:\/\//i.test(v.link.trim()) ? v.link.trim() : `https://${v.link.trim()}`) : null;
    onChange([...items, { title: v.title.trim(), link, price: Number(v.price) || 0, qty: Number(v.qty) || 1 }]);
    setV({ title: "", link: "", price: "", qty: 1 });
  };
  return (
    <div className="space-y-2">
      <ItemsList items={items} onRemove={(j) => onChange(items.filter((_, k) => k !== j))} />
      <div className="grid grid-cols-[1fr_4rem] gap-2 sm:grid-cols-[1fr_1fr_5rem_4rem_auto]">
        <Input value={v.title} onChange={(e) => setV({ ...v, title: e.target.value })} placeholder="Article (ex. fromage)" className="col-span-2 sm:col-span-1" data-testid="pot-item-title" />
        <Input value={v.link} onChange={(e) => setV({ ...v, link: e.target.value })} placeholder="Lien https://… (facultatif)" className="col-span-2 sm:col-span-1" data-testid="pot-item-url" />
        <Input type="number" min="0" step="0.01" value={v.price} onChange={(e) => setV({ ...v, price: e.target.value })} placeholder="Prix €" data-testid="pot-item-price" />
        <Input type="number" min="1" value={v.qty} onChange={(e) => setV({ ...v, qty: e.target.value })} aria-label="Quantité" data-testid="pot-item-qty" />
        <Button type="button" variant="outline" className="col-span-2 rounded-full sm:col-span-1" onClick={add} data-testid="pot-item-add"><Plus className="mr-1 h-4 w-4" />Ligne</Button>
      </div>
    </div>
  );
};

export const ShareBox = ({ total, people, testid = "pot-share" }) => (
  <div className="saving-strong flex flex-wrap items-baseline justify-between gap-2 px-4 py-3" data-testid={testid}>
    <span className="text-sm">Total des achats <b className="num">{eur(total)}</b>{people ? ` ÷ ${people} pers.` : ""}</span>
    {people && total > 0 ? <span className="num text-xl font-black text-success">{eur(total / people)} / personne</span> : <span className="text-xs text-muted-foreground">Indiquez le nombre de personnes</span>}
  </div>
);
